import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './core/domain/interceptors/auth.interceptor';
import { loadingInterceptor } from './core/domain/interceptors/loading.interceptor';
import { errorInterceptor } from './core/domain/interceptors/error.interceptor';
import { InitialDataRepository } from './core/domain/repositories/initial-data/initial-data.repository';
import { InitialDataRepositoryImplementation } from './core/infrastructure/repositories/initial-data/initial-data.repository.implementation';
import { TarifaRepository } from './core/domain/repositories/tarifa/tarifa.repository';
import { TarifaRepositoryImplementation } from './core/infrastructure/repositories/tarifa/tarifa.repository.implementation';
import { LeadRepository } from './core/domain/repositories/lead/lead.repository';
import { LeadRepositoryImplementation } from './core/infrastructure/repositories/lead/lead.repository.implementation';
import { QuoteRepository } from './core/domain/repositories/quote/quote.repository';
import { QuoteRepositoryImplementation } from './core/infrastructure/repositories/quote/quote.repository.implementation';
import { AdvisorRepositoryImplementation } from './core/infrastructure/repositories/advisor/advisor.repository.implementation';
import { AdvisorRepository } from './core/domain/repositories/advisor/advisor.repository';
import { PetDataLayerRepository } from './core/domain/repositories/tagging/PetDataLayer.repository';
import { PetDataLayerRepositoryImplementation } from './core/infrastructure/repositories/tagging/PetDataLayer.repository.implementation';

/**
 * Configuración principal de la aplicación.
 * Registra router, HttpClient e interceptores.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),

    // Router con lazy loading y preload de todos los módulos
    provideRouter(routes, withPreloading(PreloadAllModules)),

    // HttpClient con interceptores funcionales en orden de ejecución
    provideHttpClient(
      withInterceptors([
        // 1. Auth — inyecta el token Bearer
        authInterceptor,
        // 2. Loading — activa el spinner global
        loadingInterceptor,
        // 3. Error — captura errores 5xx y redirige a /error-500
        errorInterceptor,
      ]),
    ),

    { provide: InitialDataRepository, useClass: InitialDataRepositoryImplementation },
    { provide: TarifaRepository, useClass: TarifaRepositoryImplementation },
    { provide: LeadRepository, useClass: LeadRepositoryImplementation },
    { provide: QuoteRepository, useClass: QuoteRepositoryImplementation },
    { provide: AdvisorRepository, useClass: AdvisorRepositoryImplementation },
    { provide: PetDataLayerRepository, useClass: PetDataLayerRepositoryImplementation }

  ],
};

